module.exports = __webpack_public_path__ + "static/media/order_blu_active.cade6ef2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order_blu_active.png
// module id = 1648
// module chunks = 0